import { createFileRoute } from '@tanstack/react-router';
import { HostProductPlaceholder } from '@/lib/nav/HostProductPlaceholder';

export const Route = createFileRoute('/verified-badge')({
  component: VerifiedBadgePlaceholder,
});

// Seam route (spec §5.11, plan §9b) — post-launch, flags.hostProducts +
// entity.namibia_ltd. See HostProductPlaceholder's header comment.
function VerifiedBadgePlaceholder() {
  return <HostProductPlaceholder title="Verified badge" />;
}
